/**
 * PublicFooter — rodapé simples para páginas públicas (landing, login,
 * cadastro, agendamento público). NÃO deve ser usado dentro do CRM
 * autenticado — lá o rodapé de logout/marca já vive na Sidebar.
 *
 * Mobile-first: empilha centralizado com toques grandes (min-h-44px nos
 * links). Desktop: uma única linha horizontal, itens separados por "·".
 */
const FOOTER_LINKS = [
    { label: "Termos de Uso", href: "/termos" },
    { label: "Política de Privacidade", href: "/privacidade" },
    { label: "Suporte", href: "mailto:suporte@kinng.app" },
];

const PublicFooter = () => (
    <footer data-testid="public-footer" className="bg-black/30 py-6 px-4">
        <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-0 text-center">
            <span className="text-xs sm:text-sm text-slate-500">
                © {new Date().getFullYear()} Kinng.app — Todos os direitos reservados
            </span>
            {FOOTER_LINKS.map((link) => (
                <span key={link.label} className="flex items-center">
                    <span className="hidden sm:inline mx-2 text-slate-700">·</span>
                    <a
                        href={link.href}
                        data-testid={`public-footer-${link.label === "Suporte" ? "suporte" : link.href.replace("/", "")}`}
                        className="min-h-[44px] flex items-center px-2 sm:px-0 text-xs sm:text-sm text-slate-500 hover:text-slate-300 hover:underline transition-colors"
                    >
                        {link.label}
                    </a>
                </span>
            ))}
        </div>
    </footer>
);

export default PublicFooter;
